import React from 'react';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import DbeDatePicker from '../../../../Components/Inputs/DbeDatePicker';

const MassiveDatePicker = function MassiveDatePicker({
  name = '',
  time = false,
  defaultValue = new Date(),
  label = '',
  ...others
}) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) =>
        time ? (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              ampm={false}
              renderInput={(props) => <TextField {...props} />}
              label={label}
              value={value}
              onChange={onChange}
              {...others}
            />
          </LocalizationProvider>
        ) : (
          <DbeDatePicker
            label={label}
            date={value}
            onChange={onChange}
            {...others}
          />
        )
      }
    />
  );
};

MassiveDatePicker.propTypes = {
  name: PropTypes.string,
  time: PropTypes.bool,
  defaultValue: PropTypes.object,
  label: PropTypes.string,
  others: PropTypes.object,
};

export default MassiveDatePicker;
